module.exports = __webpack_public_path__ + "img/logo.5bb64809.png";